<template>
  <div class="level-stage-container">
    <LevelDemo :levels="Packets.level" />
  </div>
</template>

<script>
import LevelDemo from "../components/LevelDemo";
export default {
  data() {
    return {
      Packets: {
        id: 111,
        level: {
          taskLevelArray: [
            {
              id: 1,
              order: 1,
              totalScore: 15,
              isLocked: false,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 2,
              order: 2,
              totalScore: 17,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 3,
              totalScore: 19,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 4,
              totalScore: 20,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 5,
              totalScore: 21,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 6,
              totalScore: 22,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 7,
              totalScore: 23,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },

            {
              id: 1434343,
              order: 1,
              totalScore: 16,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              type: 1,
            },
            {
              id: 1434343,
              order: 8,
              totalScore: 18,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 9,
              totalScore: 19,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 10,
              totalScore: 20,
              isLocked: false,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 11,
              totalScore: 21,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 12,
              totalScore: 22,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 13,
              totalScore: 24,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 14,
              totalScore: 17,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 2,
              totalScore: 18,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              type: 1,
            },
            {
              id: 1434343,
              order: 15,
              totalScore: 19,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 16,
              totalScore: 20,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 17,
              totalScore: 21,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 18,
              totalScore: 23,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 19,
              totalScore: 25,
              isLocked: false,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 20,
              totalScore: 25,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 21,
              totalScore: 25,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              tryCounter: [0, 0, 0, 0, 0],
              type: 0,
            },
            {
              id: 1434343,
              order: 3,
              totalScore: 25,
              isLocked: true,
              isCompleted: false,
              rating: 0,
              type: 1,
            },
          ],
        },
      },
    };
  },
  components: {
    LevelDemo,
  },
};
</script>

<style lang="postcss" scoped>
.level-stage-container {
  background: url("../assets/images/background-class.png");
  font-family: "Roboto", sans-serif;
}
</style>
